// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2eQQ7","Success":"Button_Success__2zEBI","Danger":"Button_Danger__2i_VZ"};